// URL del CATÁLOGO público de empleados (employee-portal). Es OTRA SPA, así que
// no vale window.location.origin: va por env con fallback al dominio productivo
// — el mismo criterio (y el mismo par env/fallback) que el menú «Portales» de
// components/Layout.tsx, que ahora también lo lee de aquí.
//
// OJO a la forma: función con cuerpo y el env en una variable intermedia. Con la
// versión de una línea (`const f = (): string => (import.meta as any).env?.X`)
// el build de Rollup falla al parsear este módulo — no la «simplifiques».
export function employeePortalUrl(): string {
  const env: any = (import.meta as any).env || {};
  return env.VITE_EMPLOYEE_PORTAL_URL || 'https://employees.usewai.com';
}
